import * as type from '../../actions/index.types'

export function loginReducer(state = {
  loading: false,
  reloginLoading: true,
  loginData: null,
  registerData: null,
  error: null,
  // Set when an employee is blocked by the society geofence at sign-in. Holds
  // the backend message; the login page shows it with a "Retry" button.
  geofenceError: null
}, action) {

  switch (action.type) {
    case type.REGISTER:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case type.REGISTER_SUCCESS: {

      return {
        ...state,
        error: null,
        loading: false,
        registerData: action.payload,
      }
    }
    case type.REGISTER_FAILURE:
      return {
        ...state,
        error: action?.message || 'Somthing went wrong.',
        loading: false,
      }
    case type.LOGIN:
      console.log(action)
      return {
        ...state,
        loading: true,
        reloginLoading: action?.data?.autoLogin ? true : false,
        error: null,
        geofenceError: null,
      }
    case type.LOGIN_GEOFENCE_BLOCKED:
      return {
        ...state,
        loading: false,
        reloginLoading: false,
        error: null,
        geofenceError: action?.message
          || 'You must be at your society premises to sign in.',
      }
    case type.LOGIN_SUCCESS: {

      return {
        ...state,
        error: null,
        loading: false,
        reloginLoading: false,
        loginData: action.payload,
      }
    }
    case type.LOGIN_FAILURE:
      return {
        ...state,
        error: action?.message || 'Somthing went wrong.',
        loading: false,
        reloginLoading: false
      }


    case type.RELOGIN:
      return {
        ...state,
        reloginLoading: true,
        error: null,
      }

    case type.RELOGIN_SUCCESS: {

      return {
        ...state,
        loginData: action.payload,
        error: null,
        loading: false,
        reloginLoading: false,
      }
    }

    case type.RELOGIN_FAILURE:
      return {
        ...state,
        error: action?.message || 'Somthing went wrong.',
        loading: false,
        reloginLoading: false
      }

    // The profile page's sidebar and its Cancel button both read from
    // loginData.user, which is only ever written at login. Without merging the
    // saved profile back in, a successful update left the store holding the
    // pre-edit values — so Cancel reverted the form to them.
    case type.CTRL_UPDATE_PROFILE_SUCCESS: {
      const updatedUser = action?.payload?.data;
      if (!updatedUser || !state.loginData) return state;
      return {
        ...state,
        loginData: {
          ...state.loginData,
          user: { ...state.loginData.user, ...updatedUser },
        },
      }
    }

    case type.LOGOUT:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case type.LOGOUT_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      }
    case type.LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.message || 'Somthing went wrong.',
      }

    default:
      return state
  }
}